<template>
    <ac-modal title="Edit Group" ref="modalRef" :size-class="'modal-lg'" data-keyboard="false" data-backdrop="static">
        <template>
            <div class="row">
                <div class="info-board info-board-blue">
                    <h4>General Information</h4>
                    <p>
                        Group name and basic info.
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6 form-group">
                    <label>Name</label>
                    <small><span class="redText">required </span></small>
                    <input type="text" class="form-control " placeholder="Name" v-model="groupData.name">
                </div>
                <div class="col-lg-4 col-md-6 form-group">
                    <white-label-drop-down v-model="groupData.whiteLabelId"></white-label-drop-down>
                </div>
                <div class="col-lg-4 col-md-6 form-group">
                    <label for="companyType">Type</label>
                    <select id="companyType" type="text" class="form-control " v-model="groupData.companyTypeId">
                        <option v-for="ct in companyTypes" :value="ct.companyTypeId">
                            {{ ct.companyType }}
                        </option>
                    </select>
                </div>
                <div class="col-lg-4 col-md-6 form-group">
                    <label for="ein">EIN</label>
                    <small><span class="redText">required </span></small>
                    <ac-masked-text-box id="ein" v-model="groupData.ein" :isAlphaNumeric="true"
                        :mask="'00-0000000-aaaa'"></ac-masked-text-box>
                </div>
                <div class="col-lg-4 col-md-6 form-group">
                    <label for="ediFilePath">EDI Filepath</label>
                    <input id="ediFilePath" type="text" class="form-control" v-model="groupData.ediFilePath">
                </div>
                <div class="col-lg-4 col-md-6 form-group">
                    <label for="benefitEligible">Benefit Eligible</label>
                    <input id="benefitEligible" type="text" class="form-control" v-model="groupData.benefitEligible">
                </div>
                <div class="col-lg-4 col-md-6 form-group">
                    <label for="groupId">Group Id</label>
                    <input id="groupId" type="text" class="form-control" v-model="groupData.groupId">
                </div>
                <div class="col-lg-4 col-md-6 form-group" v-if="this.hasEDI != false">
                    <label for="AMFCode">AMF Code</label>
                    <input id="AMFCode" type="text" class="form-control" v-model="groupData.amfCode">
                </div>
                <div class="col-lg-4 col-md-6 form-group">
                    <label for="effStartDate">Group Benefit Start Date</label>
                    <ac-date-picker :useTodayAsDefault="false" v-model="groupData.effStartDate"></ac-date-picker>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <label>Text Banner</label>
                    <br>
                    <small class="acressaBlueText" :class="{ 'red-background': plainBannerError }">
                        Character count cannot exceed 250 characters. Character Count: {{ plainBannerLength }}
                    </small>
                    <div id="textBanner">
                        <textarea class="form-control" maxlength="500" name="description" value="" v-model="bannerText"
                            placeholder="Include a customized banner message that will appear on the member dashboard.">
                        </textarea>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <label>Invoice Summary Message</label>
                    <br>
                    <small class="acressaBlueText" :class="{ 'red-background': invoiceSummaryError }">
                        Character count cannot exceed 150 characters. Character Count: {{ invoiceSummaryLength }}
                    </small>
                    <div id="invoiceSummaryMessage">
                        <textarea class="form-control" maxlength="150" name="invoiceSummaryMessage"
                            v-model="invoiceSummaryMessage"
                            placeholder="Enter a custom message to display on the Group Contribution Report Invoice Summary.">
                        </textarea>
                    </div>
                </div>
            </div>

            <hr>
            <h4>Payment Options</h4>
            <div class="row">
                <div class="col-lg-7">
                    <p>Payment Method</p>
                </div>
                <div class="col-lg-5">
                    <div class="switch">
                        <label title="Uneditable">
                            ACH
                            <input disabled type="checkbox" v-model="groupData.isCredit">
                            <span class="lever"></span> Credit Card
                        </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-7">
                    <p>Defer Payment Method</p>
                </div>
                <div class="col-lg-5">
                    <div class="switch">
                        <label title="Uneditable">
                            No
                            <input disabled type="checkbox" v-model="groupData.deferPayment">
                            <span class="lever"></span> Yes
                        </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-7">
                    <p>Hide Physician Pricing</p>
                </div>
                <div class="col-lg-5">
                    <div class="switch">
                        <label>
                            No
                            <input type="checkbox" v-model="groupData.hidePhysicianPricing">
                            <span class="lever"></span> Yes
                        </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-7">
                    <p>Exclude Employer from NACHA file</p>
                </div>
                <div class="col-lg-5">
                    <div class="switch">
                        <label>
                            No
                            <input type="checkbox" v-model="groupData.excludeFromNacha">
                            <span class="lever"></span> Yes
                        </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-7">
                    <p>Exclude Employer from Payroll Deductions NACHA file</p>
                </div>
                <div class="col-lg-5">
                    <div class="switch">
                        <label>
                            No
                            <input type="checkbox" v-model="groupData.excludeFromPayrollDeductionNacha">
                            <span class="lever"></span> Yes
                        </label>
                    </div>
                </div>
            </div>

            <hr>
            <div>
                <h4>Group Settings</h4>
                <div class="row">
                    <div class="col-lg-7">
                        <p>Allow Auto Enrollment</p>
                    </div>
                    <div class="col-lg-5">
                        <div class="switch">
                            <label>
                                No
                                <input type="checkbox" v-model="groupData.allowAutoEnrollment">
                                <span class="lever"></span> Yes
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-7">
                        <p>Allow Primary Member to Add Dependents</p>
                    </div>
                    <div class="col-lg-5">
                        <div class="switch">
                            <label>
                                No
                                <input type="checkbox" v-model="groupData.allowAddDependents">
                                <span class="lever"></span> Yes
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-7">
                        <p>Coverage Changes Cannot Begin in Current Month</p>
                    </div>
                    <div class="col-lg-5">
                        <div class="switch">
                            <label>
                                No
                                <input type="checkbox" v-model="groupData.restrictFamilyChanges">
                                <span class="lever"></span> Yes
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-7">
                        <p>Suppress Member Emails and Messages</p>
                    </div>
                    <div class="col-lg-5">
                        <div class="switch">
                            <label>
                                No
                                <input type="checkbox" v-model="groupData.suppressEmailsAndMessages">
                                <span class="lever"></span> Yes
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-7">
                        <p>Require Member SSN</p>
                    </div>
                    <div class="col-lg-5">
                        <div class="switch">
                            <label>
                                No
                                <input type="checkbox" v-model="groupData.ssnRequired">
                                <span class="lever"></span> Yes
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-7">
                        <p>Family Bucket Contribution</p>
                    </div>
                    <div class="col-lg-5">
                        <div class="switch">
                            <label title="Uneditable">
                                No
                                <input disabled type="checkbox" v-model="groupData.isFamilyContribution">
                                <span class="lever"></span> Yes
                            </label>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-lg-12">
                        <h4>Member Out-of-Pocket Payment Method</h4>
                        <out-of-pocket-payment-options :value="outOfPocketOptionDisplay" :read-only="true" />
                    </div>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-xs-12">
                    <div class="modal-footer">
                        <div class="button-box">
                            <ac-button class="btn btn-sm btn-red" :action="closeModal">Cancel</ac-button>
                            <ac-button class="btn btn-sm btn-green" :action="updateGroup">Update Group</ac-button>
                        </div>
                    </div>
                </div>
            </div>
            <br />
        </template>
        <ac-auto-reset-modal ref="VerifySelection" :path="'pages/root/components/shared/VerifySelectionModal.vue'">
        </ac-auto-reset-modal>
    </ac-modal>
</template>

<script>
import { common } from "../../../../global/common.js";
import { api } from "../../../../global/framework/api.js";
import WhiteLabelDropDown from "../create/WhiteLabelDropDown.vue";
import ProviderAssignment from "../create/ProviderAssignment.vue";
import OutOfPocketPaymentOptions from "../../../../components/shared/company/OutOfPocketPaymentOptions.vue";
import { configTables } from "../../../../global/configTables";
import { notifications } from "@/global/notifications.js";

export default {
    name: "EditGroupModal",
    components: { ProviderAssignment, WhiteLabelDropDown, OutOfPocketPaymentOptions },
    data() {
        return {
            companyId: null,
            groupData: {
                customTextBanner: ""
            },
            companyTypes: [],
            whiteLabels: [],
            bannerText: '',
            plainBannerLength: 0,
            plainBannerError: false,
            invoiceSummaryMessage: '',
            invoiceSummaryLength: 0,
            invoiceSummaryError: false,
            hasEDI: false
        };
    },
    computed: {
        outOfPocketOptionDisplay() {
            const cc = this.groupData.allowCreditCardPayments;
            const pd = this.groupData.allowPayrollDeductions;
            if (cc && !pd) return 1;
            if (!cc && pd) return 2;
            if (cc && pd) return 3;
            return 1;
        }
    },
    watch: {
        bannerText(newVal) {
            this.plainBannerLength = this.getBannerLength(newVal);
            this.plainBannerError = this.plainBannerLength > 250 ? true : false;
        },
        invoiceSummaryMessage(newVal) {
            this.invoiceSummaryLength = (newVal || '').length;
            this.invoiceSummaryError = this.invoiceSummaryLength > 150;
        }
    },
    methods: {
        async showModal(companyId) {
            this.companyId = companyId;
            let groupData, benefitEligible;
            
            [groupData, benefitEligible] = await Promise.all([
                api.getData('Company', companyId, 'GetCompanyById'),
                api.getData('Company', companyId, 'GetCompanyBenefitEligible')
            ]);
            
            groupData.benefitEligible = benefitEligible;
            this.groupData = groupData;

            this.hasEDI = this.groupData.ediFilePath != null && this.groupData.ediFilePath != undefined;
            this.bannerText = this.groupData.customTextBanner;
            this.invoiceSummaryMessage = this.groupData.invoiceSummaryMessage || '';
            this.companyTypes = await configTables.getCompanyTypes();
            this.bannerText = this.groupData.customTextBanner;
            this.$refs.modalRef.open();
        },
        closeModal() {
            this.$refs.modalRef.close();
        },
        async updateGroup() {
            this.save();
        },
        async getNetworks() {
            let result = await api.get('Shared', this.companyId, 'GetNetworks');
            return result;

        },
        async getIndependents() {
            return api.get('Shared', this.companyId, 'GetIndependentClinicsAndPhysicians');
        },
        checkSelectedProvider(selection) {
            let others = this.groupData.associatedProviders.filter(ap => ap.providerEntityId !== selection.providerEntityId);
            if (selection.isChecked) {
                others.push(selection);
            }
            this.groupData.associatedProviders = others;
        },
        initializeState(selections) {
            this.groupData.associatedProviders.push(...selections);
        },
        async save() {
            if (this.plainBannerLength > 250) {
                notifications.showError({ message: "Custom Banner exceeds size limits.", title: "Error" });
                return;
            } else if (this.invoiceSummaryLength > 150) {
                notifications.showError({ message: "Invoice Summary Message exceeds size limits.", title: "Error" });
                return;
            } else {
                this.groupData.customTextBanner = this.bannerText;
                this.groupData.invoiceSummaryMessage = this.invoiceSummaryMessage;
                let result = await api.post('admin', 'UpdateCompany', this.groupData);
                if (result) {
                    this.closeModal();
                }
            }
        },
        getBannerLength(fullBannerText) {
            let tempElement = document.createElement('div');
            tempElement.innerHTML = fullBannerText;
            let text = tempElement.textContent || tempElement.innerText;
            return text.length;
        }
    },
}
</script>

<style scoped>
.modal-footer {
    padding-left: 0;
    padding-right: 0;
}

.red-background {
    background-color: red
}
</style>